import { render, staticRenderFns } from "./OrderInfoDetailSection.vue?vue&type=template&id=12e317b9&"
import script from "./OrderInfoDetailSection.vue?vue&type=script&lang=ts&"
export * from "./OrderInfoDetailSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports